import * as authorize from '../../oauth2/authorize';
import * as signinWidget from '../../signin-widget';


export function initAuthorize(oktaAuth) {
  authorize.init(signinWidget.getLoginContainerData(), oktaAuth);
}
